export const styles = theme => ({
    section: {
        marginBottom: 40
    }
});
